import { createTheme } from "@mui/material";

export const theme = createTheme({
	typography: {
		fontFamily: "var(--font-family)",
	},
	components: {
		MuiDialogTitle: {
			styleOverrides: {
				root: {
					padding: "8px 16px",
					fontSize: "16px",
					fontWeight: 600,
				},
			},
		},
		MuiDialogContent: {
			styleOverrides: {
				root: {
					padding: "0 16px",
				},
			},
		},
		MuiDialogActions: {
			styleOverrides: {
				root: {
					paddingLeft: "16px",
					paddingRight: "16px",
				},
			},
		},
	},
	mixins: {
		scrollbarMixin: {
			"&::-webkit-scrollbar": {
				width: "var(--scrollbar-width)",
			},
			"&::-webkit-scrollbar-track": {
				background: "var(--scrollbar-track-background)",
			},
			"&::-webkit-scrollbar-thumb": {
				background: "var(--scrollbar-thumb-background)",
			},
			"&::-webkit-scrollbar-thumb:hover": {
				background: "var(--scrollbar-thumb-hover-background)",
			},
		},
	},
});
